/* eslint-disable arrow-body-style */
import { SelectInput } from '@abyss/web/ui/SelectInput';
import React from 'react';
import { constants } from '@src/routes/provider/common/constants';
import {
  linkAnalysisFilterPanelApi,
  useLinkAnalysisFilterPanelStore,
} from '../../mothership/linkAnalysisFilterPanel.state';
import { linkAnalysisId } from '../../types';

export const TypeSelect = () => {
  const options = useLinkAnalysisFilterPanelStore(
    (state) => state.idTypeOptions
  );
  const value = useLinkAnalysisFilterPanelStore(
    (state) => state.idTypeSelected
  );
  const validationMsg = useLinkAnalysisFilterPanelStore(
    (state) => state.idTypeValidationMsg
  );
  const loading = useLinkAnalysisFilterPanelStore((state) => state.loading);
  const placeholder = loading ? constants.LOADING : 'Select an ID Type';
  const renderValue = loading ? '' : value;
  const { setTypeValue } = linkAnalysisFilterPanelApi;

  return (
    <div
      data-cy={`${linkAnalysisId}SelectType`}
      data-value={value}
      data-options={JSON.stringify(options)}
      data-valid={!validationMsg}
      data-loading={loading}
    >
      <SelectInput
        label="ID Type"
        placeholder={placeholder}
        value={renderValue}
        onChange={setTypeValue}
        options={options}
        errorMessage={validationMsg}
        isLoading={loading}
      />
    </div>
  );
};
